import { atom } from "recoil";
import { route } from "../router/route";

export const headerTriggerState = atom({
  key: "headerTriggerState",
  default: false,
});

export const headerMenuState = atom({
  key: "headerMenuState",
  default: [
    {
      title: "1:1 컨설팅",
      activation: true,
      src: `${route.consulting}`,
      childCategories: [
        {
          title: "1:1 컨설팅이란?",
          activation: true,
          src: `${route.consulting}`,
        },
        {
          title: "사전 상담 받기",
          activation: true,
          src: `${route.consulting_prior}`,
        },
        {
          title: "신청하기",
          activation: true,
          src: `${route.consulting_apply}`,
        },
        {
          title: "진행 중인 컨설팅",
          activation: true,
          src: `${route.consulting_progress}`,
        },
      ],
    },
    {
      title: "고객센터",
      activation: true,
      src: `${route.customer_service_notice}`,
      childCategories: [
        {
          title: "공지사항",
          activation: true,
          src: `${route.customer_service_notice}`,
        },
        {
          title: "1:1 문의",
          activation: true,
          src: `${route.customer_service_ask}`,
        },
        {
          title: "FAQ",
          activation: true,
          src: `${route.customer_service_faq}`,
        },
        {
          title: "이용약관",
          activation: true,
          src: `${route.customer_service_terms_use}`,
        },
      ],
    },
    {
      title: "마이페이지",
      activation: true,
      src: `${route.my_page_setting}`,
      childCategories: [
        {
          title: "계정 관리",
          activation: true,
          src: `${route.my_page_setting}`,
        },
        {
          title: "내 활동 관리",
          activation: true,
          src: `${route.my_page_activity}`,
        },
        {
          title: "나의 강의실",
          activation: true,
          src: `${route.my_page_classroom}`,
        },
        {
          title: "스크랩",
          activation: true,
          src: `${route.my_page_scrap}`,
        },
        {
          title: "결제 내역",
          activation: true,
          src: `${route.my_page_payment}`,
        },
      ],
    },
  ],
});
